<template>
  <v-sheet border class="bg-card rounded-lg mx-7 my-2" width="280">
    <div class="d-flex flex-row justify-center align-center py-2">
      <v-icon :icon="icon" class="material-icons-round mr-1"></v-icon>
      <div class="text-subtitle-1">{{title}}</div>
    </div>
    <v-divider></v-divider>
    <div class="mt-2 ml-1 mb-2">
        <div v-for="item in content" :key="item" class="ml-2 pa-1 d-flex align-start">{{item}}</div>
    </div>
  </v-sheet>
</template>

<script>
import { mapState } from "vuex";
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    icon: String,
    title: String,
    content: Array,
  },
  computed: {
    ...mapState({ $_darkMode: "darkMode" }),
  },
});
</script>

<style scoped lang="scss">

</style>
